import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { observable, set } from "mobx";
import { withRouter } from "react-router-dom";

@inject("store")
@observer
class MapPoints extends Component {
  @observable showAll = false;

  constructor(props) {
    super(props);

    // defines what actions should be passed back to the parent component
    // make sure to .bind(this) to the immediate function
    this.props.actions({
      click: this.pointClick.bind(this)
    });
  }

  // this function is passed back to the parent component
  // function is called from the parent since PointTracker stops
  // all event propagation.
  pointClick = pointerEvent => {
    // gets the map point data from data-point attr
    const getPoint = id => {
      return this.props.store.points.filter(o => o[this.props.store.layer] == 1).find(o => o.id == id);
    };

    // for the map marker div
    const mapMarker = pointerEvent.target.className == "map-marker" ? pointerEvent.target : null;
    if (mapMarker) {
      const point = getPoint(mapMarker.dataset.point);
      if (point) {
        this.props.onClickPoint(point);
        this.props.onClickPopup(point);
        // ga("send", "event", "LB City", point.label, "Popup Opened");
      dataLayer.push({
        'event': 'gaEvent',
        'eventCategory': 'LB City - ' + this.props.store.layer,
        'eventAction': "Popup Opened",
        'eventLabel': point.label
      });
      }
    }

    // for the slideout div
    const mapMarkerSlideout = pointerEvent.target.className == "map-marker--slideout" ? pointerEvent.target : null;
    if (mapMarkerSlideout) {
      const point = getPoint(mapMarkerSlideout.dataset.point);
      if (point) {
        this.props.onClickPopup(point);
      }
    }
  };

  getSlideoutSize({ label }) {
    return { width: `${label.length * 8 + 15}px` };
  }

  componentDidMount() {
    this.animateIn();
  }

  componentDidUpdate(prevProps) {
    if (this.props.store.layer !== prevProps.store.layer) {
      this.animateIn();
    }
  }

  animateIn() {
    this.showAll = false;
    setTimeout(() => {
      this.showAll = true;
    }, 750);
  }

  getStyles() {
    let o = {};
    if (this.props.scale) {
      // scale is between 1 and 2
      // scale should be 100% at 2x zoom
      // scale should be 200% when zoomed out
      const scale = 0.588 * this.props.scale + 2 - this.props.scale;

      // offset is between 0 and 14
      // offset should be 14 at 2x zoom
      // offset should be 0 when zoomed out
      const size = -6.8 * this.props.scale + 14;

      o.transform = `scale(${scale}) translate(${size}px, ${-size}px)`;
    }
    return o;
  }

  render() {
    let data = this.props.store.points;
    let region = localStorage.getItem("zennerOrSensus");
    if(this.props.store.layer == "smart" && region == "Sensus"){
      data = data.filter((o) => {
        return(
        [o[this.props.store.layer] == 1,
        o.sensus != 0].every(x => x))
      });
    }
    if(this.props.store.layer == "smart" && region == "Sensus"){
      data = data.filter((o) => {
        return(
        [o[this.props.store.layer] == 1,
        o.zenner != 0].every(x => x))
      });
    }
    return (
      <div className="map-points" style={{ zIndex: 999, position: "relative" }}>
        {data
          .filter(o => o[this.props.store.layer] == 1)
          .sort((a, b) => a.sort - b.sort)
          .map(o => (
            <div
              key={o.id}
              id={o.id}
              style={{ top: o.y - 65, left: o.x + 5, ...this.getStyles() }}
              className={`map-marker--wrap ${this.props.store.point == o.id ? "active" : ""} ${o.flip ? "flipped" : ""}  ${o.flip2 ? "flipped2" : ""}  ${
                this.showAll ? "show" : ""
              }`}
            >
              {/* 
                                This all leads back to PointTracker stopping event propagation
                                The className and data-point attributes are used to match up
                                the click event to the correct action. Please do not change 
                                these values.
                            */}

              {/* !! DO NOT CHANGE THE CLASS NAME OR REMOVE DATA-POINT !! */}
              <div className="map-marker" data-point={o.id}>
                {/* <img src="/city/assets/marker.png"></img> */}
              </div>

              {/* !! DO NOT CHANGE THE CLASS NAME OR REMOVE DATA-POINT !! */}
              <div className="map-marker--slideout" data-point={o.id} style={this.getSlideoutSize(o)}>
                {o.label}
              </div>
            </div>
          ))}
      </div>
    );
  }
}

export default withRouter(MapPoints);
